// Mock data for notifications and messages
export const notifications = [
  {
    id: 'n001',
    title: '教職員離開校園',
    titleEn: 'Staff Left School Campus',
    content: '張老師 2025-06-20 16:37:22 離開校園。',
    contentEn: 'Ms.Zhang left the school campus at 16:37:22',
    timestamp: '2025-06-20 16:37:23',
    isRead: false,
    avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=50&h=50&fit=crop&crop=face',
    type: 'staff_movement',
    sender: 'Staff Left School Campus'
  },
  {
    id: 'n002',
    title: '教職員到達校園',
    titleEn: 'Staff Arrived School Campus',
    content: '陳老師 2025-06-20 06:45:57 到達校園。',
    contentEn: 'Mr. Chen arrived the school campus at 06:45:57',
    timestamp: '2025-06-20 06:45:58',
    isRead: false,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=50&h=50&fit=crop&crop=face',
    type: 'staff_movement',
    sender: 'Staff Arrived School Campus'
  },
  {
    id: 'n003',
    title: '教職員離開校園',
    titleEn: 'Staff Left School Campus',
    content: '王老師 2025-06-19 16:46:22 離開校園。',
    contentEn: 'Ms.Wang left the school campus at 16:46:22',
    timestamp: '2025-06-19 16:46:23',
    isRead: false,
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=50&h=50&fit=crop&crop=face',
    type: 'staff_movement',
    sender: 'Staff Left School Campus'
  },
  {
    id: 'n004',
    title: '學生遲到通知',
    titleEn: 'Student Late Arrival',
    content: 'S1B班 陳俊熙 於 2025-06-20 08:15:30 到達學校。',
    contentEn: 'S1B Chan Tsun Hei arrived at school at 08:15:30',
    timestamp: '2025-06-20 08:15:31',
    isRead: false,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&h=50&fit=crop&crop=face',
    type: 'student_late',
    sender: 'Student Late Arrival'
  },
  {
    id: 'n005',
    title: '緊急通告',
    titleEn: 'Emergency Notice',
    content: '由於天氣惡劣，今日下午活動取消，請各位注意安全。',
    contentEn: 'Due to severe weather, afternoon activities are cancelled. Please stay safe.',
    timestamp: '2025-06-20 12:30:15',
    isRead: false,
    avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=50&h=50&fit=crop&crop=face',
    type: 'emergency',
    sender: 'Emergency Notice'
  },
  {
    id: 'n006',
    title: '教職員到達校園',
    titleEn: 'Staff Arrived School Campus',
    content: '李老師 2025-06-19 07:15:42 到達校園。',
    contentEn: 'Ms. Lee arrived the school campus at 07:15:42',
    timestamp: '2025-06-19 07:15:43',
    isRead: true,
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=50&h=50&fit=crop&crop=face',
    type: 'staff_movement',
    sender: 'Staff Arrived School Campus'
  },
  {
    id: 'n007',
    title: '學生請假通知',
    titleEn: 'Student Leave Notice',
    content: 'S2A班 黃美玲 今日因病請假，已通知家長。',
    contentEn: 'S2A Wong Mei Ling is on sick leave today, parents have been notified.',
    timestamp: '2025-06-19 08:45:20',
    isRead: true,
    avatar: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=50&h=50&fit=crop&crop=face',
    type: 'student_leave',
    sender: 'Student Leave Notice'
  },
  {
    id: 'n008',
    title: '教職員離開校園',
    titleEn: 'Staff Left School Campus',
    content: '吳老師 2025-06-18 17:20:15 離開校園。',
    contentEn: 'Mr. Wu left the school campus at 17:20:15',
    timestamp: '2025-06-18 17:20:16',
    isRead: true,
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50&h=50&fit=crop&crop=face',
    type: 'staff_movement',
    sender: 'Staff Left School Campus'
  }
];

export const groupMessages = [
  {
    id: 'gm001',
    groupName: 'S1B班級群組',
    sender: '陳老師',
    message: '各位家長好，明天的數學測驗請提醒孩子準備計算機。',
    timestamp: '2025-06-22 16:30',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face',
    type: 'teacher'
  },
  {
    id: 'gm002',
    groupName: 'S1B班級群組',
    sender: '李美玲媽媽',
    message: '請問明天的體育課需要帶什麼用品嗎？',
    timestamp: '2025-06-22 15:45',
    avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=40&h=40&fit=crop&crop=face',
    type: 'parent'
  },
  {
    id: 'gm003',
    groupName: 'S1B班級群組',
    sender: '黃老師',
    message: '體育課請穿運動鞋，帶毛巾和水壺。',
    timestamp: '2025-06-22 15:50',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=40&h=40&fit=crop&crop=face',
    type: 'teacher'
  },
  {
    id: 'gm004',
    groupName: 'S1B班級群組',
    sender: '王子軒爸爸',
    message: '謝謝老師的提醒！',
    timestamp: '2025-06-22 15:52',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=40&h=40&fit=crop&crop=face',
    type: 'parent'
  },
  {
    id: 'gm005',
    groupName: 'S1B班級群組',
    sender: '莊老師',
    message: '下週一的英文口試，請各位同學準備3分鐘的自我介紹。',
    timestamp: '2025-06-22 14:20',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=40&h=40&fit=crop&crop=face',
    type: 'teacher'
  }
];

// Enhanced eNotices with comprehensive structure for multiple functionality
export const eNotices = [
  {
    id: 'en001',
    title: '2024-2025年度校運會通知',
    content: '本校將於2025年6月30日（星期一）舉行45屆校運會，當日學校會正常開放，請各位家長留意以下安排。',
    publishDate: '2025-06-20',
    publishTime: '14:32',
    publisher: '學校行政',
    category: '學校活動',
    tags: ['運動會', '學校活動'],
    priority: 'high',
    status: 'published',
    targetAudience: ['全校', '家長', '學生'],
    responseDeadline: '2025-06-28',
    viewCount: 0,
    readStatus: false,
    
    // Attachments
    attachments: [
      {
        id: 'att001',
        name: '校運會詳細安排.pdf',
        size: '2.5 MB',
        type: 'pdf',
        url: '/attachments/sports_day_arrangement.pdf',
        downloadCount: 0
      },
      {
        id: 'att002',
        name: '參賽項目報名表.pdf',
        size: '1.2 MB',
        type: 'pdf',
        url: '/attachments/sports_registration_form.pdf',
        downloadCount: 0
      }
    ],
    
    // Actions required from parents/students
    actionsRequired: [
      {
        id: 'act001',
        type: 'participation_intent',
        title: '參與意向',
        description: '請表明是否參加校運會',
        options: [
          { id: 'participate', label: '參加', selected: false },
          { id: 'no_time', label: '沒有時間參加', selected: false }
        ],
        required: true,
        deadline: '2025-06-28'
      },
      {
        id: 'act002',
        type: 'payment',
        title: '運動服訂購',
        description: '校運會運動服訂購',
        amount: 150,
        currency: 'HKD',
        paymentMethods: ['信用卡', '銀行轉帳', '支付寶'],
        required: false,
        deadline: '2025-06-25'
      }
    ],
    
    // Replies and responses
    replies: [
      {
        id: 'rep001',
        parentId: null,
        author: '陳美玲家長',
        content: '請問運動會當日是否需要帶午餐？',
        timestamp: '2025-06-21 09:15',
        isRead: true,
        replies: [
          {
            id: 'rep002',
            parentId: 'rep001',
            author: '學校行政',
            content: '當日學校會提供午餐，家長無需準備。',
            timestamp: '2025-06-21 10:30',
            isRead: false
          }
        ]
      }
    ],
    
    // Forward information
    forwardable: true,
    forwardHistory: [],
    
    // Additional info links
    additionalInfo: [
      {
        id: 'info001',
        title: '校運會歷史回顧',
        url: '/info/sports_day_history',
        type: 'internal_link'
      },
      {
        id: 'info002',
        title: '運動安全指引',
        url: '/info/sports_safety_guidelines',
        type: 'internal_link'
      }
    ]
  },
  
  {
    id: 'en002',
    title: '期末考試時間表及注意事項',
    content: '2024-2025學年第二學期期末考試將於7月第一週進行，現將考試時間表及注意事項通知如下。',
    publishDate: '2025-06-15',
    publishTime: '16:45',
    publisher: '教務處',
    category: '學術事務',
    tags: ['考試', '時間表'],
    priority: 'high',
    status: 'published',
    targetAudience: ['全校', '家長', '學生'],
    responseDeadline: '2025-06-25',
    viewCount: 23,
    readStatus: true,
    
    attachments: [
      {
        id: 'att003',
        name: '期末考試時間表.pdf',
        size: '1.8 MB',
        type: 'pdf',
        url: '/attachments/final_exam_schedule.pdf',
        downloadCount: 15
      },
      {
        id: 'att004',
        name: '考試規則及注意事項.pdf',
        size: '950 KB',
        type: 'pdf',
        url: '/attachments/exam_rules.pdf',
        downloadCount: 12
      }
    ],
    
    actionsRequired: [
      {
        id: 'act003',
        type: 'acknowledgment',
        title: '確認收到',
        description: '確認已收到並了解考試安排',
        required: true,
        deadline: '2025-06-25',
        completed: true,
        completedDate: '2025-06-16 14:20'
      }
    ],
    
    replies: [
      {
        id: 'rep003',
        parentId: null,
        author: '黃志明家長',
        content: '請問考試期間是否有補課安排？',
        timestamp: '2025-06-16 08:30',
        isRead: true,
        replies: [
          {
            id: 'rep004',
            parentId: 'rep003',
            author: '教務處',
            content: '考試期間不會安排補課，請同學專心準備考試。',
            timestamp: '2025-06-16 11:45',
            isRead: false
          }
        ]
      }
    ],
    
    forwardable: true,
    forwardHistory: [
      {
        forwardedBy: '陳美玲家長',
        forwardedTo: '家長WhatsApp群組',
        timestamp: '2025-06-16 12:00'
      }
    ],
    
    additionalInfo: [
      {
        id: 'info003',
        title: '考試溫習技巧',
        url: '/info/study_tips',
        type: 'internal_link'
      }
    ]
  },
  
  {
    id: 'en003',
    title: '暑期補課班報名通知',
    content: '為協助同學鞏固學習基礎，本校將於暑假期間開辦多個補課班，現開始接受報名。',
    publishDate: '2025-06-10',
    publishTime: '10:15',
    publisher: '課外活動組',
    category: '課外活動',
    tags: ['暑期', '補課', '報名'],
    priority: 'medium',
    status: 'published',
    targetAudience: ['全校', '家長', '學生'],
    responseDeadline: '2025-06-30',
    viewCount: 45,
    readStatus: false,
    
    attachments: [
      {
        id: 'att005',
        name: '暑期補課班資料.pdf',
        size: '3.2 MB',
        type: 'pdf',
        url: '/attachments/summer_classes_info.pdf',
        downloadCount: 28
      }
    ],
    
    actionsRequired: [
      {
        id: 'act004',
        type: 'registration',
        title: '報名',
        description: '選擇參加的補課班',
        options: [
          { id: 'math', label: '數學補課班', fee: 800, selected: false },
          { id: 'english', label: '英語補課班', fee: 750, selected: false },
          { id: 'chinese', label: '中文補課班', fee: 750, selected: false },
          { id: 'science', label: '科學補課班', fee: 850, selected: false }
        ],
        required: false,
        deadline: '2025-06-30'
      },
      {
        id: 'act005',
        type: 'payment',
        title: '補課班費用',
        description: '所選補課班的費用',
        amount: 0, // Will be calculated based on selection
        currency: 'HKD',
        paymentMethods: ['信用卡', '銀行轉帳', '現金'],
        required: false,
        deadline: '2025-07-05'
      }
    ],
    
    replies: [],
    forwardable: true,
    forwardHistory: [],
    
    additionalInfo: [
      {
        id: 'info004',
        title: '師資介紹',
        url: '/info/summer_teachers',
        type: 'internal_link'
      },
      {
        id: 'info005',
        title: '上課地點及時間',
        url: '/info/class_schedule_location',
        type: 'internal_link'
      }
    ]
  },
  
  {
    id: 'en004',
    title: '學期補課班報名班通知',
    content: '各位同學及家長，為了讓同學在暑假期間也能持續學習，學校將舉辦暑期補課班，詳情請參閱附件。',
    publishDate: '2025-06-08',
    publishTime: '14:20',
    publisher: '教務處',
    category: '學術事務',
    tags: ['補課班', '報名'],
    priority: 'medium',
    status: 'published',
    targetAudience: ['全校'],
    responseDeadline: '2025-06-19',
    viewCount: 67,
    readStatus: true,
    
    attachments: [
      {
        id: 'att006',
        name: '暑期補課班報名表.pdf',
        size: '1.5 MB',
        type: 'pdf',
        url: '/attachments/summer_class_registration.pdf',
        downloadCount: 34
      }
    ],
    
    actionsRequired: [
      {
        id: 'act006',
        type: 'form_submission',
        title: '提交報名表',
        description: '填寫並提交暑期補課班報名表',
        required: false,
        deadline: '2025-06-19',
        completed: false
      }
    ],
    
    replies: [
      {
        id: 'rep005',
        parentId: null,
        author: '李小明家長',
        content: '請問補課班的上課時間是怎樣安排的？',
        timestamp: '2025-06-09 16:20',
        isRead: true,
        replies: []
      }
    ],
    
    forwardable: true,
    forwardHistory: [],
    additionalInfo: []
  }
];

// Notice categories for filtering
export const noticeCategories = [
  '全部',
  '學校活動', 
  '學術事務',
  '課外活動',
  '行政通知',
  '緊急通知',
  '家長會',
  '繳費通知'
];

// Notice action types
export const actionTypes = {
  participation_intent: '參與意向',
  payment: '繳費',
  registration: '報名',
  form_submission: '表格提交',
  acknowledgment: '確認收到',
  survey: '問卷調查',
  booking: '預約',
  order: '訂購'
};

// Helper functions for eNotice management
export const getNoticeById = (id) => {
  return eNotices.find(notice => notice.id === id);
};

export const getNoticesByCategory = (category) => {
  if (category === '全部') return eNotices;
  return eNotices.filter(notice => notice.category === category);
};

export const getUnreadNotices = () => {
  return eNotices.filter(notice => !notice.readStatus);
};

export const getNoticesWithPendingActions = () => {
  return eNotices.filter(notice => 
    notice.actionsRequired.some(action => 
      action.required && !action.completed
    )
  );
};

export const markNoticeAsRead = (noticeId) => {
  const notice = getNoticeById(noticeId);
  if (notice) {
    notice.readStatus = true;
    notice.viewCount += 1;
  }
};

export const addReplyToNotice = (noticeId, reply) => {
  const notice = getNoticeById(noticeId);
  if (notice) {
    notice.replies.push({
      id: `rep${Date.now()}`,
      parentId: reply.parentId || null,
      author: reply.author,
      content: reply.content,
      timestamp: new Date().toLocaleString('zh-HK'),
      isRead: false,
      replies: []
    });
  }
};

export const updateActionStatus = (noticeId, actionId, status) => {
  const notice = getNoticeById(noticeId);
  if (notice) {
    const action = notice.actionsRequired.find(act => act.id === actionId);
    if (action) {
      action.completed = status;
      if (status) {
        action.completedDate = new Date().toLocaleString('zh-HK');
      }
    }
  }
};

export const downloadAttachment = (noticeId, attachmentId) => {
  const notice = getNoticeById(noticeId);
  if (notice) {
    const attachment = notice.attachments.find(att => att.id === attachmentId);
    if (attachment) {
      attachment.downloadCount += 1;
      // In real implementation, this would trigger file download
      console.log(`Downloading ${attachment.name}`);
    }
  }
}; 